// ============================================================================
//  quoteEndpoint — wybór endpointu API wyceny wg środowiska Vite.
//  Hooki środowiska blokują pliki .env*, więc endpoint produkcyjny wybieramy
//  po fladze PROD zamiast przez .env.production. Jawna zmienna
//  VITE_QUOTE_ENDPOINT (np. z shella przy buildzie) zawsze nadpisuje fallbacki.
// ============================================================================

const PROD_ENDPOINT = 'https://epufloor.app/api/hoopncourt/3d/quotes'
const DEV_ENDPOINT = 'https://dev.epufloor.app/api/hoopncourt/3d/quotes'

// env: obiekt kształtu import.meta.env ({ VITE_QUOTE_ENDPOINT?, PROD }).
export function resolveQuoteEndpoint(env) {
  return env.VITE_QUOTE_ENDPOINT || (env.PROD ? PROD_ENDPOINT : DEV_ENDPOINT)
}
